module.exports = __webpack_public_path__ + "img/caps.bc56156c.jpeg";